module.exports = __webpack_public_path__ + "static/img/IN@3x.085ab440.jpg";